const { registerBlockType } = wp.blocks;

import Editor from "./Editor";
import Save from "./Save";

registerBlockType('banner/block', {
    title: 'Banner',
    description: '',
    icon: 'image-rotate-right',
    attributes: {
        url: {
            type: 'string',
        },
    },
    edit: props => <Editor {...props} />,
    save: props => <Save {...props} />
});